<div class="card">
<div class="bodySection">
    <div class="leftSection">
        <img src="../assets/images/icons/general/login-banner.png"  class="leftImg" alt="" />
    </div>
    <div *ngIf="resetPasswordScreen" class="rightSection">
        <div class="imgSection">
            <div class="heading">Password Reset</div>
            <div class="heading-content">Enter a new password </div>
        </div>
        <form [formGroup]="resetPasswordForm" (ngSubmit)="resetPassword()">
            <div class="reset-form">
                <div class="input">
                    <fieldset class="field-set">
                        <div class="form-field input-new-password">
                            <label class="input-pwd">New password</label>
                            <div class="password-input password">
                               <input type='password' formControlName="createPassword" placeholder="New Password" (keyup)="handlePasswordChange($event)" (focusout)="handlePasswordChange($event)"/>
                            </div>
                        </div>
                        <p class="errorContent">
                            
                            <span [style.visibility]=" errorCreatePasswordMsg ? 'visible' : 'hidden'">
                                <img src="../assets/images/icons/general/information-icon (2).svg"/>
                                Password must contain atleast 6 characters</span>
                        </p>
                        <div class="form-field input-new-password">
                            <label class="input-pwd">Confirm password</label>
                            <div class="password-input password">
                               <input type='password' formControlName="confirmPassword"
                               placeholder="Confirm Password"(keyup)="handleConfirmPasswordChange($event)" (focusout)="handleConfirmPasswordChange($event)" />
                            </div>
                        </div>
                        <p class="errorContent">


                            <span [style.visibility]=" errorConfirmPasswordMsg ? 'visible' : 'hidden'">Password mismatch</span>
                        </p>
                    </fieldset>
                </div>
                <!-- Add login Error message here -->
                <p class="errorContent errcontentSize"><span *ngIf="resetPasswordError">{{resetPasswordError}}</span></p>
                           
                <div class="form-buttons form-button-section" >
                    <button type="submit" [class]="resetPasswordButton">Reset password</button>
                </div>
            </div>
        </form>
        <p class="app-version non-menu">{{currentApplicationVersion}}</p>
    </div>
    <div *ngIf="!resetPasswordScreen" class="reset-success">
        <div class="reset-head-message">Well Done!</div>
        <div class="reset-sub-message">Your password has been changed successfully. Please use your new password to login!</div>
        <button type="submit" [class]="resetPasswordButton" (click)="goToPage('login')" >Login</button>
    </div>
</div>


